import _ from 'lodash'
import { ALL_MENUS_TREE } from '../components/GlobalSidebar/menus'
import check from '../helpers/basic-check'
const { isArray, isObject } = check

/**** ==================================处理 currentUser的数据（START）================================== ****/
export const dealWithMenus = (data) => {
  const _data = JSON.parse(JSON.stringify(data))
  const { menus } = _data
  const _menus = JSON.parse(JSON.stringify(menus))
  const _allMenusTree = ALL_MENUS_TREE
  const _allMenusData = formatAllMenusTree(ALL_MENUS_TREE)
  // console.log(_allMenusData, '====3333 --obj')
  // 数据扁平化
  const authMenusObj = flatAuthArrToObjByCode(_menus)
  // console.log(authMenusObj, '====authMenusObj --obj')
  const pathWithUrl = _filterMenuUrls(_allMenusTree, authMenusObj)
  const newMenus = _filterMenus(_allMenusData, authMenusObj)
  return {
    ..._data,
    menus: newMenus,
    pathWithUrl,
  }
}

// 对原来的menu进行子sn统计
const formatAllMenusTree = (arr) => {
  if (!isArray(arr)) {
    return []
  }
  let newAllMenus = []

  for (let v of arr) {
    const { children } = v
    if (!children || !children.length) {
      let nowV = {
        ...v,
        childrenSn: [],
      }
      newAllMenus = [...newAllMenus, nowV]
      continue
    }
    const nowV = {
      ...v,
      children: formatAllMenusTree(children),
      childrenSn: getSnArr(children),
    }
    newAllMenus = [...newAllMenus, nowV]
  }

  return newAllMenus
}

// 获取每个层级下的所有的子菜单sn
const getSnArr = (list) => {
  let arr = []

  for (let v of list) {
    const { children, sn } = v
    if (children && children.length > 0) {
      const snData = getSnArr(children)
      arr = [...arr, ...snData]
    } else {
      arr = [...arr, sn]
    }
  }
  return arr
}

// 把所有数组 以code 为key 进行hash
const flatAuthArrToObjByCode = (arr) => {
  let _obj = {}
  if (!isArray(arr)) {
    return _obj
  }
  for (let v of arr) {
    const { children, code } = v
    if (children && children.length !== 0) {
      _obj[code] = v
      _obj = {
        ...flatAuthArrToObjByCode(children),
        ..._obj,
      }
    } else {
      _obj[code] = v
    }
  }
  return _obj
}

const _filterMenuUrls = (menus, authMenusObj) => {
  if (!isArray(menus) || !isObject(authMenusObj)) {
    return []
  }
  let pathWithUrl = []
  for (let v of menus) {
    const { children, sn } = v
    if (!children || !children.length) {
      if (authMenusObj[sn]) {
        if (authMenusObj[sn].url) {
          const nowUrl = {
            sn: sn,
            path: v.path,
            url: authMenusObj[sn].url,
          }
          pathWithUrl = [...pathWithUrl, nowUrl]
        }
      }
      continue
    }
    if (authMenusObj[sn]) {
      const nowUrls = _filterMenuUrls(children, authMenusObj)
      pathWithUrl = [...pathWithUrl, ...nowUrls]
    }
  }
  return pathWithUrl
}

// 这个 不但进行了过滤 还进行了 对象合并
const _filterMenus = (menus, authMenusObj) => {
  if (!isArray(menus) || !isObject(authMenusObj)) {
    return []
  }
  const hasAuthSN = Object.keys(authMenusObj)
  let newMenus = []

  for (let v of menus) {
    const { children, sn, isDevShow, childrenSn } = v

    if (isDevShow) {
      const nowV = {
        ...v,
        children: _filterMenus(children || [], authMenusObj),
      }
      newMenus = [...newMenus, nowV]
      continue
    }

    if (!children || !children.length) {
      if (authMenusObj[sn]) {
        let nowV = {
          ...v,
          ...authMenusObj[sn],
          children: [],
        }
        newMenus = [...newMenus, nowV]
      }
      continue
    }
    const compareArr = _.intersection(childrenSn, hasAuthSN) || []
    if (childrenSn && childrenSn.length > 0 && compareArr.length > 0) {
      let authObj = {}
      if (authMenusObj[sn]) {
        authObj = { ...authMenusObj[sn] }
      }
      const nowV = {
        ...v,
        ...authObj,
        children: _filterMenus(children, authMenusObj),
      }
      newMenus = [...newMenus, nowV]
      continue
    }
    if (authMenusObj[sn]) {
      const nowV = {
        ...v,
        ...authMenusObj[sn],
        children: _filterMenus(children, authMenusObj),
      }
      newMenus = [...newMenus, nowV]
    }
  }
  return newMenus
}

/**** ==================================处理 currentUser的数据（END）================================== ****/

// 把所有数组 以code 为key 进行hash
export const flatAuthArrToObjByKey = (key, arr) => {
  let _obj = {}
  if (!isArray(arr)) {
    return _obj
  }
  for (let v of arr) {
    const { children } = v
    const _key = v[key]

    if (children && children.length !== 0) {
      _obj[_key] = v
      _obj = {
        ...flatAuthArrToObjByKey(key, children),
        ..._obj,
      }
    } else {
      _obj[_key] = v
    }
  }
  return _obj
}

export const menu_func_auth = (path, menus) => {
  // 生成以 path 变量 为key 的hash
  const flatPathObj = flatAuthArrToObjByKey('path', menus)
  const { functionMenu } = flatPathObj[path] || {}
  if (!functionMenu || !functionMenu.length) {
    return {}
  }
  return flatAuthArrToObjByCode(functionMenu)
}

// // 获取所有菜单权限的ID
// export const getAllHasAuthID = (menus) => {
//   if (!menus || !menus.length) {
//     return []
//   }
//   return menus.reduce((pre, next) => {
//     const { children, id, isAuthorize } = next
//     if (!isAuthorize) {
//       return pre
//     }
//     if (!children || !children.length) {
//       return [...pre, id]
//     }
//     return [...pre, id, ...getAllHasAuthID(children)]
//   }, [])
// }

// 获取所有菜单权限的ID-- (只本文件使用)
// const getAllInitID = (menus) => {
//   if (!menus || !menus.length) {
//     return []
//   }
//   return menus.reduce((pre, next) => {
//     const { children, id, name, enName } = next
//     if (!children || !children.length) {
//       return [
//         ...pre,
//         {
//           id,
//           name,
//           enName,
//         },
//       ]
//     }
//     return [
//       ...pre,
//       {
//         id,
//         name,
//         enName,
//       },
//       ...getAllInitID(children),
//     ]
//   }, [])
// }

// 获取所有菜单有功能权限的ID-- (只本文件使用)
// const getAllHasAuthInitID = (menus) => {
//   if (!menus || !menus.length) {
//     return []
//   }
//   return menus.reduce((pre, next) => {
//     const { children, id, isAuthorize } = next
//     if (!children || !children.length) {
//       if (isAuthorize) {
//         return [...pre, id]
//       }
//       return pre
//     }
//     if (isAuthorize) {
//       return [...pre, id, ...getAllHasAuthInitID(children)]
//     }
//     return [...pre, ...getAllHasAuthInitID(children)]
//   }, [])
// }

// 获取每个菜单对应的功能权限
// export const getMenuFuncHash = (arr, obj, hasAuthObj) => {
//   let _obj = obj || {}
//   let _hasAuthObj = hasAuthObj || {}
//   if (!isArray(arr)) {
//     return _obj
//   }
//   for (let v of arr) {
//     const { children, functionMenu, id } = v
//     if (!children || !children.length) {
//       // 处理 functionMenu
//       _obj[id] = getAllInitID(functionMenu)
//       _hasAuthObj[id] = getAllHasAuthInitID(functionMenu)
//     } else {
//       getMenuFuncHash(children, _obj, _hasAuthObj)
//     }
//   }
//   return {
//     allMenuFuncHash: _obj,
//     hasAuthMenuFuncHash: _hasAuthObj,
//   }
// }

// getMenuHash 方法是获取 多层级菜单下面 所有最底层菜单
// export const getFuncMenus = (arr, obj) => {
//   return arr.reduce((pre, next) => {
//     const { children, id } = next
//     if (!children || !children.length) {
//       return [...pre, id]
//     }
//     const now = getFuncMenus(children, obj)
//     obj[id] = now
//     getMenuHash(children, obj)
//     return [...pre, ...now]
//   }, [])
// }

// export const getMenuHash = (arr, obj) => {
//   let _obj = obj || {}
//   for (let v of arr) {
//     const { children, id } = v
//     if (children && children.length) {
//       _obj[id] = getFuncMenus(children, _obj)
//     }
//   }
//   return _obj
// }

// 拿到点击菜单下面所有的子菜单
export const getAllChildMenusHash = (arr = [], obj) => {
  const _obj = obj || {}
  for (let v of arr) {
    const { children, id } = v
    if (children && children.length) {
      _obj[id] = getChild(children, _obj)
    } else {
      _obj[id] = []
    }
  }
  return _obj
}

export const getChild = (arr, obj) => {
  return arr.reduce((pre, next) => {
    const { children, id } = next
    if (!children || !children.length) {
      obj[id] = []
      return [...pre, id]
    }
    const now = getChild(children, obj)
    obj[id] = now
    getAllChildMenusHash(children, obj)
    return [...pre, ...now]
  }, [])
}

// 拿到点击菜单所有的父菜单 ID
// export const getAllParentMenusHash = (arr) => {
//   // 首先扁平化数组
//   if (!arr || !arr.length) {
//     return {}
//   }
//   const flatArrr = flatArrByKey(arr, 'children')
//   let _obj = {}
//   for (let v of flatArrr) {
//     const { parentId, id } = v
//     if (parentId === 0) {
//       _obj[id] = []
//     } else {
//       _obj[id] = getParents(flatArrr, parentId)
//     }
//   }
//   return _obj
// }

// 数组扁平化
// export const flatArrByKey = (arr, key) => {
//   return arr.reduce((pre, next) => {
//     const child = next[key]
//     if (child && child.length) {
//       return [...pre, next, ...flatArrByKey(child, key)]
//     }
//     return [...pre, next]
//   }, [])
// }

// export const getParents = (flatArrr, parentId) => {
//   return flatArrr.reduce((pre, next) => {
//     if (next.id === parentId) {
//       return [...pre, next.id]
//     }
//     return pre
//   }, [])
// }

// export const addAuthForAllData = (data) => {
//   return data.map((address) => {
//     const { buildingWithFloors } = address
//     return {
//       ...address,
//       buildingWithFloors: buildingWithFloors.map((v) => {
//         const { floors } = v
//         if (floors && floors.length) {
//           const _floors = floors.map((value) => {
//             return {
//               ...value,
//               isAuthorize: true,
//             }
//           })
//           return {
//             ...v,
//             floors: _floors,
//           }
//         }
//         return v
//       }),
//     }
//   })
// }

// // 寻找菜单的所有同级兄弟菜单
// export const getMenuBrothers = (arr, obj) => {
//   let _obj = obj || {}
//   for (let v of arr) {
//     const { children, id } = v
//     _obj[id] = getArr(arr, id)
//     if (children && children.length) {
//       getMenuBrothers(children, _obj)
//     }
//   }

//   return _obj
// }

// export const getArr = (arr, id) => {
//   return arr
//     .reduce((pre, next) => {
//       return [...pre, next.id]
//     }, [])
//     .filter((v) => v !== id)
// }

// 把 树形数组 进行 一固定的key 进行  hash (====SidebarMenu使用)
export const hashArrToObjByKey = (arr, key, childrenKey = 'children') => {
  let _obj = {}
  if (!isArray(arr)) {
    return _obj
  }
  for (let v of arr) {
    const children = v[childrenKey]
    const _key = v[key]
    if (children && children.length !== 0) {
      _obj[_key] = v
      _obj = {
        ...hashArrToObjByKey(children, key),
        ..._obj,
      }
    } else {
      _obj[_key] = v
    }
  }
  return _obj
}

// 获取 hash 对象里面 节点的父节点数组 (====SidebarMenu使用)
export const getHashParentArr = (hash, parentKey) => {
  const getPar = (hash, pid) => {
    let _pid = pid
    const arr = []

    while (hash[_pid]) {
      arr.push(_pid)
      _pid = hash[_pid][parentKey]
    }
    return arr
  }
  const obj = {}
  for (let key in hash) {
    const value = hash[key]
    const parentPath = value[parentKey]
    if (!parentPath) {
      obj[key] = [value.path] // 如果没 父菜单 ，就高亮自己
    } else {
      obj[key] = getPar(hash, parentPath)
    }
  }

  return obj
}

/**** 16进制转换成rgba ****/
export function convertColorToRgbaByHex(color, alpha = 100) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  let sColor = color.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt(`0x${sColor.slice(i, i + 2)}`, 16))
    }
    return `rgba(${sColorChange.join(',')},${alpha / 100})`
  } else {
    return sColor
  }
}

/**** 判断是否有当前menu权限 ****/
export const justifyCurrentMenuAuth = (pathCode, menuList) => {
  let _obj = { [pathCode]: false }
  if (!isArray(menuList)) {
    return _obj
  }
  const authMenusObj = flatAuthArrToObjByCode(menuList)
  const currentAuth = authMenusObj[pathCode]
  if (currentAuth) {
    _obj = { [pathCode]: true }
  }
  // for (let m of menuList) {
  //   const { code, children = [] } = m
  //   const childrenCode = children.map((c) => c.code)
  //   const allCode = [code, ...childrenCode]

  //   if (allCode.includes(pathCode)) {
  //     _obj = { [pathCode]: true }
  //     break
  //   }
  // }
  return _obj
}
